<!-- add ** "visible": ["never"] ** to the workflow-field to hide the button -->
<div *ngIf="iframeSrc && field?.visible" [class.bl-disabled]="!field?.enabled">
  <button class="bl-button bl-button-tertiary bl-width--100" (click)="openSlideInPanel()">
    <span class="bl-font-size--14 bl-font-weight--700 bl-display--flex bl-align-items--center bl-justify-content--center">
      <i class="cu-calculator bl-margin-bottom--4"></i>{{ field?.label }}
    </span>
  </button>
</div>

<ea-slide-in-panel class="half-panel" [(isSlidePanelVisible)]="isOpen" [slidePanelTitle]="field?.label">
  <iframe
    title="payment calculator"
    *ngIf="isOpen"
    class="bl-border bl-border-radius--16"
    #calc
    [src]="iframeSrc"
    width="100%"
    (load)="adjustIframeHeight($event)"
  ></iframe>
</ea-slide-in-panel>
